module.exports = __webpack_public_path__ + "img/devices.ed5cdd39.svg";